import request from './base';
import {excludeObjNullValue} from 'utils/common';

export const fetchActiveImageSetVersions = ({q, page, perPage, sortOpts, extraParams}, signal) =>
  request.fetchListEnhanced({url: '/active-image-set-versions', q, page, perPage, sortOpts, extraParams}, signal);

export const fetchAllActiveImageSetVersions = ({type, level}) =>
  request.fetchAll({url: '/active-image-set-versions', extraParams: {type, level}});

export const createActiveImageSetVersion = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    type: payload.type,
    version_code: payload.versionCode,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.postForm('/active-image-set-versions', formData);
};

export const updateActiveImageSetVersion = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    version_code: payload.versionCode,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm(`/active-image-set-versions/${payload.id}`, formData);
};

export const deleteActiveImageSetVersion = (id) => request.deleteReq(`/active-image-set-versions/${id}`);

export const fetchCommonImages = ({q, page, perPage, sortOpts, extraParams}, signal) =>
  request.fetchListEnhanced({url: '/common-images', q, page, perPage, sortOpts, extraParams}, signal);

export const fetchAllCommonImages = ({type, level}) =>
  request.fetchAll({url: '/common-images', extraParams: {type, level}});

export const createCommonImage = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    type: payload.type,
    version_code: payload.versionCode,
    level: payload.level,
    order: payload.order,
    image: payload.image,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.postForm('/common-images', formData);
};

export const updateCommonImage = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    order: payload.order,
    image: payload.image,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm(`/common-images/${payload.id}`, formData);
};

export const deleteCommonImage = (id) => request.deleteReq(`/common-images/${id}`);
